import IConfig from 'app/config/Config'

import { UserStore } from '..'

const createRetrieveParams = (
  config: IConfig,
  state: UserStore,
  code: string
) => {
  const codeVerifier = state.challenge

  if (!codeVerifier) {
    throw new Error('No code_verifier available - cannot complete OAuth flow')
  }

  // CRITICAL: The redirect_uri must match the one used in the authorization request
  // For PKCE flows initiated via web intermediary, this is config.redirectUrl
  const redirectUri = config.redirectUrl

  const params = {
    code_verifier: codeVerifier,
    grant_type: 'authorization_code',
    client_id: `${config.clientId}`,
    code,
    redirect_uri: redirectUri,
  }

  return params
}

export default createRetrieveParams
